import { useEffect, useState } from "react";
import "antd/dist/reset.css";
import "../styles/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Routes from "./Routes";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );
  const [lastLoginTime, setLastLoginTime] = useState(
    localStorage.getItem("lastLoginTime")
  );

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("organizationid");
    localStorage.removeItem("version");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("lastLoginTime");

    setIsLoggedIn(false);
    setLastLoginTime(null);
  };

  useEffect(() => {
    // alert('Checking login status immediately.');

    if (isLoggedIn) {
      const currentTime = Date.now();

      if (!lastLoginTime || currentTime - lastLoginTime > 24 * 60 * 60 * 1000) {
        logout();
      }
    }

    const intervalId = setInterval(() => {
      const currentTime = Date.now();
      const storedLastLoginTime = localStorage.getItem("lastLoginTime");
      const storedIsLoggedIn = localStorage.getItem("isLoggedIn") === "true";

      if (storedIsLoggedIn && storedLastLoginTime) {
        if (currentTime - storedLastLoginTime >= 24 * 60 * 60 * 1000) {
          logout();
        }
      }
    }, 12 * 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [isLoggedIn, lastLoginTime]);

  return <Routes />;
};

export default App;
